import { type FC, type HTMLAttributes, type Ref } from "react";
import { cn } from "../lib/utils";
import { trackingAttrs } from "../utils";

export type PartialIndicatorProps = HTMLAttributes<HTMLDivElement> & {
	/** Whether the indicator renders its active (warning) state. */
	active: boolean;
	/** Test identifier — set as `data-testid` on the root. */
	testId?: string;
	/** Analytics identifier — expands to `data-pendo-id` + `data-amp-track-id`. */
	trackingId?: string;
	ref?: Ref<HTMLDivElement>;
};

export const PartialIndicator: FC<PartialIndicatorProps> = ({
	active,
	testId,
	trackingId,
	className,
	ref,
	...rest
}) => (
	<div
		ref={ref}
		className={cn(
			"size-[10px] shrink-0 self-center rounded-full pl-1",
			active ? "bg-warning" : "bg-surface-dark",
			className,
		)}
		data-testid={testId}
		aria-hidden
		{...trackingAttrs(trackingId)}
		{...rest}
	/>
);
PartialIndicator.displayName = "PartialIndicator";
